import React, { Component, useState } from 'react';

const FilledText = (props) => {
    return(
    <span className="form-filled-text">{props.text}</span>
    );
  };

export default FilledText;